import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { fetchTimerStatusThunk } from '@/redux/asyncThunks/timerConfiguration'

interface GamePhaseStatusFetcherProps {
  roomId: string
  pollInterval?: number
}

const GamePhaseStatusFetcher = ({
  roomId,
  pollInterval = 10000,
}: GamePhaseStatusFetcherProps) => {
  const dispatch = useAppDispatch()
  const timerWebsocketConnected = useAppSelector(
    (state) => state.timerWS.isConnected
  )

  useEffect(() => {
    if (roomId && timerWebsocketConnected) {
      const fetchStatus = () => {
        dispatch(fetchTimerStatusThunk(roomId))
          .unwrap()
          .catch((error) => {
            console.error('Error fetching timer status:', error)
          })
      }

      const initialDelay = setTimeout(() => {
        fetchStatus()
      }, 1000)

      const intervalId = setInterval(fetchStatus, pollInterval)

      return () => {
        clearTimeout(initialDelay)
        clearInterval(intervalId)
      }
    }
  }, [dispatch, roomId, pollInterval, timerWebsocketConnected])

  return null
}

export default GamePhaseStatusFetcher
